// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--2GJgl";
export var footer__icon = "Footer-module--footer__icon--37UWw";
export var footer__links = "Footer-module--footer__links--wMNVR";
export var footer__info = "Footer-module--footer__info--23vCX";
export var footer__info__copyright = "Footer-module--footer__info__copyright--aYkzq";